module.exports = __webpack_public_path__ + "img/arrow-blue.56ac3c7e.svg";